export default "__VITE_ASSET__c49efd37__"